export default __webpack_public_path__ + "static/media/skillset-development.cb488c44.svg";